import React from 'react';
import { connect } from 'react-redux';
import { Grid, withStyles, createStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Button } from 'app/components/Button';
import SplashBackground from '../../assets/img/BranchSplash01.jpg';
import { routes } from 'app/routes/route-list';
import { getImagePathSafely } from 'app/util/images';

const styles = (theme) =>
  createStyles({
    splashButton: {
      maxWidth     : '375px',
      width        : '100%',
      margin       : '95px auto 0',
      minHeight    : '75px',
      lineHeight   : '75px',
      paddingTop   : 0,
      paddingBottom: 0,
      fontSize     : '25px',
      fontWeight   : 500,
      [theme.breakpoints.down('xs')]: {
        fontSize  : 18,
        minHeight : '60px',
        lineHeight: '60px',
        marginTop : '70px',
      },
    },
    contentWrapper: {
      textAlign: 'center',
      padding  : '0 16px',
    },
    splashLogo: {
      display : 'block',
      margin  : '0 auto',
      height  : '200px',
      maxWidth: '100%',
      width   : 'auto',
      [theme.breakpoints.down('md')]: {
        height: '150px',
      },
      [theme.breakpoints.down('xs')]: {
        height: '70px',
      },
    },
  });

class SplashContainerComponent extends React.Component<any, any> {
  rootRef: React.RefObject<{}>;
  constructor(props) {
    super(props);
    this.rootRef = React.createRef();
  }

  render() {
    const { classes, logo } = this.props;
    const logoPath          = getImagePathSafely(logo);

    const backgroundStyles  = {
      background: `url('${window.location.origin}${SplashBackground}') no-repeat 50% center / cover`,
      maxWidth  : '100%',
      width     : '100%',
      height    : '100%',
      position  : 'fixed' as 'fixed',
      left      : 0,
      top       : 0,
    };

    return (
      <Grid container direction="column" justifyContent="center" style={backgroundStyles}>
        <Grid item>
          <Grid container direction="column" className={classes.contentWrapper}>
            <Grid item>
              <img className={classes.splashLogo} src={logoPath} alt="logo" />
              <Button
                className = {classes.splashButton}
                color     = "primary"
                component = {Link}
                to        = {routes.branch}
                variant   = "contained"
              >
                Get Started
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  logo: state.config.logo,
  ...ownProps,
});

export default connect(
  mapStateToProps,
  null,
)(withStyles(styles)(SplashContainerComponent));
